import React from "react";
import Rotas from "./routes";
import { SnackbarProvider } from "notistack";

function App() {
  return (
    <SnackbarProvider maxSnack={3}>
      <Rotas />
    </SnackbarProvider>
  );
}

export default App;
